// @flow

import { type Ui } from './types';

function getIgnorePhoneNumber(ui: Ui): ?bool {
  return ui['ignore_phone_number'];
}

export function shouldIgnorePhoneNumber(ui: Ui): bool {
  return !!getIgnorePhoneNumber(ui);
}
